import type { DurationMinutes, GameId } from '../games/types'

export const COPY = {
  productName: 'Bé Chơi',
  start: 'Bắt đầu chơi',
  audioReady: 'Đã bật tiếng',
  hold: 'Giữ 3 giây',
  holdHint: 'Giữ ngón tay trên vòng tròn nhé',
  parentTitle: 'Dành cho bố mẹ',
  durationLabel: 'Thời gian chơi',
  muteOff: 'Tắt tiếng',
  muteOn: 'Bật tiếng',
  endSession: 'Dừng chơi ngay',
  resetLevels: 'Chơi lại từ đầu',
  resetConfirm: 'Cho bé chơi lại từ màn 1 nhé?',
  resetYes: 'Chơi lại',
  resetNo: 'Thôi',
  done: 'Xong',
  home: 'Về nhà',
  gear: 'Cài đặt cho bố mẹ',
  winddown: 'Bé nghỉ thôi nhé.',
  guidedTitle: 'Mẹo nhỏ cho bố mẹ',
  guidedBody:
    'Vào Cài đặt › Trợ năng › Truy cập được hướng dẫn rồi bật lên. Khi bé chơi, bấm nhanh nút sườn 3 lần để giữ bé ở trong ứng dụng, bé sẽ không lỡ tay thoát ra ngoài nữa.',
  guidedDone: 'Đã hiểu',
  games: {
    peekaboo: 'Ú òa',
    animals: 'Con gì kêu?',
    colors: 'Màu & hình',
    'folk-songs': 'Đồng dao',
    drums: 'Trống vui',
    puzzle: 'Xếp hình',
  } satisfies Record<GameId, string>,
} as const

export function minutesLabel(minutes: DurationMinutes): string {
  return `${minutes} phút`
}
